/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Sklik_HintInputs */

const cs_form_sklik_hint = /** @type {(inputs: Form_Sklik_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volitelné štítky Sklik PI3 (max. 50 znaků). Plná lead-gen integrace je v Integrace → Sklik.`)
};

const en_form_sklik_hint = /** @type {(inputs: Form_Sklik_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optional Sklik PI3 product-ad labels (max 50 chars). Full Sklik lead-gen lives under Integrations → Sklik.`)
};

/**
* | output |
* | --- |
* | "Optional Sklik PI3 product-ad labels (max 50 chars). Full Sklik lead-gen lives under Integrations → Sklik." |
*
* @param {Form_Sklik_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_sklik_hint = /** @type {((inputs?: Form_Sklik_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Sklik_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_sklik_hint(inputs)
	return cs_form_sklik_hint(inputs)
});